export const FIXED_SECTION_KEYS = {
  document_project_details: "Document and Project Details",
  document_authorization: "Document Authorization"
};

export const DEFAULT_SECTION_KEYS = {
  high_risk_activities: "High Risk Activities",
  risk_matrix: "Risk Assessment Matrix",
  job_steps_hazards_consequences_controls: "Job Steps, Hazards, Consequences & Controls",
  emergency_contacts: "Emergency Contacts"
};

export const sectionBodyMessageByBucket = {
  fixed: "Fixed section placeholder.",
  default: "Default section placeholder.",
  method_item_type: "Dynamic Method Item Type placeholder. Dedicated component wiring is next.",
  swms_content_management: "Dynamic SWMS Content Management placeholder. Dedicated component wiring is next.",
  unsupported: "Unsupported section placeholder. Section key is preserved safely."
};

export const formatSectionLabel = (sectionKey, sectionData) => {
  if (sectionData && sectionData.display_name) {
    return sectionData.display_name;
  }

  return sectionKey
    .split("_")
    .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
    .join(" ");
};

export const resolveSectionConfig = (sectionKey, sectionData) => {
  const sectionType = sectionData && sectionData.type ? sectionData.type : "unknown";

  if (FIXED_SECTION_KEYS[sectionKey]) {
    return {
      bucket: "fixed",
      heading: FIXED_SECTION_KEYS[sectionKey],
      sectionType
    };
  }

  if (DEFAULT_SECTION_KEYS[sectionKey]) {
    return {
      bucket: "default",
      heading: DEFAULT_SECTION_KEYS[sectionKey],
      sectionType
    };
  }

  if (sectionType === "method_item_type" || sectionKey.startsWith("method_item_type_")) {
    return {
      bucket: "method_item_type",
      heading: formatSectionLabel(sectionKey, sectionData),
      sectionType: "method_item_type"
    };
  }

  if (sectionType === "swms_content_management" || sectionKey.startsWith("swms_content_management_")) {
    return {
      bucket: "swms_content_management",
      heading: formatSectionLabel(sectionKey, sectionData),
      sectionType: "swms_content_management"
    };
  }

  return {
    bucket: "unsupported",
    heading: formatSectionLabel(sectionKey, sectionData),
    sectionType
  };
};